import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/styles";
import React, { useState } from "react";
import ResponsiveLayout from "../../../../../shared/components/ResponsiveLayout";
import ResponsiveDialog from "../../../../../shared/components/ResponsiveDialog";

const useStyles = makeStyles((theme) => ({
  MuiAccordionroot: {
    padding: 0,
    minHeight: 64,
    "&.MuiAccordion-root:before": {
      backgroundColor: "white",
    },
    "&.Mui-expanded": {
      margin: 0,
      marginBottom: 12,
    },
  },
  MuiAccordionSummaryroot: {
    padding: 0,
  },
  MuiAccordionSummaryexpandIcon: {
    color: theme.palette.secondary.main,
    paddingRight: 0,
    paddingLeft: 0,
  },
  MuiAccordionSummarycontent: {
    margin: 0,
    "&.Mui-expanded": {
      margin: 0,
    },
  },
}));

export default function AdditionalDataCupsInformationDialog({
  infoData,
  onClose,
}) {
  const classes = useStyles();
  const [state, setState] = useState({
    expandedItem: 1,
  });
  const { palette } = useTheme();
  const { expandedItem } = state;

  const onChange = (item) => (event, newItem) => {
    setState((s) => ({ ...s, expandedItem: newItem ? item : false }));
  };

  return (
    <>
      <ResponsiveDialog
        PaperProps={{
          "aria-label": "Additional data cups information dialog",
        }}
        displayCondition={true}
        fullScreenCondition={true}
        open={true}
        onClose={onClose}
      >
        <Container style={{ padding: "1rem 1rem", height: "100%" }}>
          <ResponsiveLayout>
            <Box className="appear-anim" style={{ paddingTop: "50px" }}>
              {infoData.map((infoItem, index) => (
                <Accordion
                  key={index}
                  expanded={expandedItem === index}
                  onChange={onChange(index)}
                  elevation={0}
                  classes={{ root: classes.MuiAccordionroot }}
                >
                  <AccordionSummary
                    expandIcon={<i className="material-icons">expand_more</i>}
                    classes={{
                      root: classes.MuiAccordionSummaryroot,
                      expandIcon: classes.MuiAccordionSummaryexpandIcon,
                      content: classes.MuiAccordionSummarycontent,
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{ color: palette.text.title }}
                    >
                      <strong>{infoItem.title}</strong>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    style={{
                      padding: 0,
                    }}
                  >
                    {infoItem.description}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </ResponsiveLayout>
        </Container>
      </ResponsiveDialog>
    </>
  );
}
